// src/main.jsx
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./components/theme-provider";

// AG Grid
import { ClientSideRowModelModule } from "ag-grid-community";
import { ModuleRegistry, AllEnterpriseModule, LicenseManager, IntegratedChartsModule ,RowGroupingModule, RowGroupingPanelModule } from "ag-grid-enterprise";
import { AgChartsEnterpriseModule} from "ag-charts-enterprise";
import { AG_GRID_LICENSE_KEY } from "./constants/constant";
import { registerServiceWorker } from "./pwa/registerServiceWorker";
import { enforceSessionPolicy } from "./utils/authSession";
ModuleRegistry.registerModules([ClientSideRowModelModule,AllEnterpriseModule,RowGroupingModule, RowGroupingPanelModule,IntegratedChartsModule.with(AgChartsEnterpriseModule)]);

// Set your license key globally
LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);

// Apply the Remember Me policy before any auth check runs
enforceSessionPolicy();

createRoot(document.getElementById("root")).render(
  // <StrictMode>
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme" >
    <App />
    <Toaster duration={3000}  position="bottom-center"  expand={false}    />
    </ThemeProvider>
  // </StrictMode>
);

registerServiceWorker();